export default "__VITE_ASSET__D4FNgcSW__"